export default theme => ({
  root: {
    paddingTop: 15,
    marginLeft: 15,
    marginTop: 12,
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  iconSmall: {
    fontSize: 20,
  },
});
